module.exports = __webpack_public_path__ + "img/error_icon.36e7ef45.svg";